

































































import Vue from 'vue'
import { Col, Row, Input, Button } from 'element-ui'
import { TranscodingRegion, AWSRegion, WRTCServer } from '@/types/admin'
import Modal from '@/components/Modal'
import WRTCServerSummary from './WRTCServerSummary'
import WRTCLoadbalancer from '@/classes/WRTCLoadbalancer'
import SubscribeWowzaStats from '@/mixins/SubscribeWowzaStats'
import './RegionSummary.scss'
import { KeyDict } from '@/types'

export default Vue.extend({
  name: 'RegionSummary',
  mixins: [SubscribeWowzaStats],
  props: {
    region: {
      type: Object as () => TranscodingRegion,
      required: true
    },
    regionid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    showAddNew: false,
    serverid: ''
  }),
  computed: {
    awsregion (): AWSRegion {
      return this.region.awsregion
    },
    rtmpserver (): string {
      return this.region.rtmpserver === null ? 'None' : this.region.rtmpserver
    },
    nimbleserver (): string {
      return this.region.nimbleserver === null ? 'None' : this.region.nimbleserver
    },
    name (): string {
      return this.region.name
    },
    wrtcservers (): KeyDict<WRTCServer> {
      return this.region.wrtcserver
    },
    nextwrtcserver (): string {
      const balancer = new WRTCLoadbalancer()
      const wowzastats = this.$store.direct.state.opsmonitor.wowzastats
      return balancer.getServerUrlToStreamTo(this.region, wowzastats) ?? 'ERROR'
    }
  },
  methods: {
    addServer () {
      this.serverid = ''
      this.showAddNew = true
    },
    addServerConfirmed () {
      this.showAddNew = false
      this.$store.direct.dispatch.admin.addWowzaServerToRegion({
        serverId: this.serverid,
        region: this.regionid
      }).then(() => {
        this.$message(`Server added to region ${this.regionid}`)
      }).catch(error => {
        this.$message('Could not add server to the region: ' + error)
      })
    }
  },
  components: {
    'el-col': Col,
    'el-row': Row,
    'el-input': Input,
    'el-button': Button,
    WRTCServerSummary,
    Modal
  }
})
